'use strict';

import {ferry} from '../../../services/ferry/ferry';

function delete_cookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

export default ['$scope','$routeParams', '$timeout', function($scope, $routeParams, $timeout) {
    $scope.credentials = {};
    $scope.ui = {};
    $scope.credentials.username = "";
    $scope.credentials.password = "";
    $scope.redirect = null;
    $scope.credentials.code = null;
    if ($routeParams.error) {
        $scope.ui.showError = true;
        $scope.username = $routeParams.error;
    } else {
        $scope.ui.showError = false;
    }
    if ($routeParams.redirect) {
        $scope.redirect = $routeParams.redirect.includes('login') ?
            undefined : $routeParams.redirect;
    }
    ['JSESSIONID', 'sharewave_JWT'].forEach(to_remove => delete_cookie(to_remove));
    $scope.attemptingLogin = false;
    $scope.doLogin = function() {
        $scope.ui.showError = false;
        $scope.attemptingLogin = true;
        ferry.call('/session/login', { email: $scope.credentials.username.toLowerCase(), password: $scope.credentials.password, redirect: $scope.redirect, code: $scope.credentials.code }).then(function(x) {
            if (x.indexOf("/twofactor") > -1) {
                $scope.attemptingLogin = false;
                $scope.ui.twofactor = true;
                var tmp = x.split('/');
                $scope.credentials.authy_id = Number(tmp[tmp.length - 1]);
            } else {
                $scope.attemptingLogin = true;
                document.location.href = x;
            }
            $scope.$apply();
        }).catch(function(err) {
            $scope.ui.showError = true;
            $scope.attemptingLogin = false;
            if (!$scope.ui.twofactor) $scope.credentials.password = "";
            $scope.$apply();
            console.log(err);
        });
    };

    $scope.requestSMS = function() {
        $scope.pauseSMS = true;
        $timeout(function(){
            $scope.pauseSMS = false;
        }, 5000);
        ferry.call('/session/send_auth_code', { authy_id: $scope.credentials.authy_id });
    };

    $scope.fieldCheck = function() {
        if (!$scope.ui.twofactor) {
            return !($scope.credentials.username && $scope.credentials.password);
        } else {
            return !($scope.credentials.username && $scope.credentials.password && $scope.credentials.code);
        }
    };
}];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/login/login.js